import { render, staticRenderFns } from "./_form.team-members.page.vue?vue&type=template&id=b986ea96&scoped=true&"
import script from "./_form.team-members.page.vue?vue&type=script&lang=js&"
export * from "./_form.team-members.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b986ea96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
